import { render, staticRenderFns } from "./CargoEquipPermit.vue?vue&type=template&id=b78b83c8"
import script from "./CargoEquipPermit.vue?vue&type=script&lang=js"
export * from "./CargoEquipPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports